module.exports = __webpack_public_path__ + "static/media/set2.6d7e1093.png";